export default __webpack_public_path__ + "static/media/chart-line.181a9481.svg";